import React from "react";
import { querySlugs } from "../../../constants/calculatorApiTypes";
import UsageTab from "../components/UsageTab";
import { getQueriesUsage } from "../services";

export function CalculatorApiQueries() {
  return (
    <UsageTab
      fetchUsage={getQueriesUsage}
      labels={querySlugs}
      breakdownLabel="Tipo de consulta"
    />
  );
}
